module.exports = [() => {
    if(window.location.hash && window.location.hash.match(/story=([0-9]+)/ig)) {
        window.location.hash = window.location.hash.replace('story=', 'entry=');
    }
}];
